import { actions } from '.';

export function getPRsSucceed(payload) {
  return {
    type: actions.GET_PRS_SUCCEED,
    payload
  };
}

export function getPRsFailure() {
  return {
    type: actions.GET_PRS_FAILURE
  };
}

export function resetPRs() {
  return {
    type: actions.RESET_PRS
  };
}
